import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';

export function RecordFormFrame({
  inline,
  open,
  onOpenChange,
  title,
  description,
  dirty,
  children,
}: {
  inline: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  dirty: boolean;
  children: ReactNode;
}): JSX.Element {
  const { t } = useTranslation();
  const [confirm, setConfirm] = useState(false);
  if (inline)
    return (
      <div className="record-form flex flex-col gap-4">
        <header>
          <h1 className="text-2xl font-semibold">{title}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        </header>
        {children}
      </div>
    );
  return (
    <>
      <Sheet
        open={open}
        onOpenChange={(next) => {
          if (!next && dirty) setConfirm(true);
          else onOpenChange(next);
        }}
      >
        <SheetContent closeLabel={t('common.close')} className="sm:max-w-3xl">
          <SheetHeader>
            <SheetTitle>{title}</SheetTitle>
            <SheetDescription>{description}</SheetDescription>
          </SheetHeader>
          {children}
        </SheetContent>
      </Sheet>
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent>
          <AlertDialogTitle>{t('workTabs.unsavedTitle')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('workTabs.unsavedDescription', { name: title })}
          </AlertDialogDescription>
          <AlertDialogFooter>
            <AlertDialogCancel>{t('workTabs.keep')}</AlertDialogCancel>
            <AlertDialogAction onClick={() => onOpenChange(false)}>
              {t('workTabs.discard')}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
